import { api } from '../api';

const getVehicleList = async ({ data }) => {
  const response = await api({
    url: `Vehicles/GetVehicleList`,
    method: 'POST',
    headers: {
      'x-skip-loader': true,
    },
    data,
  });
  return response.data;
};

const downloadActivationCodeForBP = async (data) => {
  const response = await api({
    url: `Vehicles/DownloadActivationCodeForBP`,
    method: 'POST',
    responseType: 'blob',
    data,
  });

  return response.data;
};

const getUpdateVehicleLimitsList = async ({ request }) => {
  const response = await api({
    url: `Vehicles/UpdateVehicleLimitsList`,
    method: 'PUT',
    headers: {
      'x-skip-loader': true,
    },
    data: request,
  });
  return response.data;
};

const getUpdateVehiclesUsableDays = async ({ request }) => {
  const response = await api({
    url: `Vehicles/UpdateVehiclesUsableDays`,
    method: 'PUT',
    headers: {
      'x-skip-loader': true,
    },
    data: request,
  });
  return response.data;
};

const removeLimitRestriction = async ({ request }) => {
  const response = await api({
    url: `Vehicles/removeLimitRestriction`,
    method: 'POST',
    headers: {
      'x-skip-loader': true,
    },
    data: request,
  });
  return response.data;
};

const getUpdateVehicleDisable = async ({ request }) => {
  const response = await api({
    url: `Vehicles/UpdateVehicleDisable`,
    method: 'PUT',
    headers: {
      'x-skip-loader': true,
    },
    data: request,
  });
  return response.data;
};

const deletePlateAllDevices = async ({ request }) => {
  const response = await api({
    url: `Vehicles/DeleteVehicle`,
    method: 'DELETE',
    headers: {
      'x-skip-loader': true,
    },
    data: request,
  });
  return response.data;
};

const getVehicleSummaryPdfReport = async (data) => {
  const response = await api({
    url: `Vehicles/vehicleSummaryReport`,
    method: 'GET',
    headers: {
      'x-skip-loader': true,
    },
    params: data,
    responseType: 'arraybuffer',
  });
  return response.data;
};

const getDownloadVehicleFile = async (data) => {
  const response = await api({
    url: `Vehicles/downloadVehicleFile`,
    method: 'GET',
    headers: {
      'x-skip-loader': true,
    },
    params: data,
    responseType: 'blob',
  });
  return response.data;
};

const createVehicleDepartments = async ({ request }) => {
  const response = await api({
    url: `VehicleDepartments/create`,
    method: 'POST',
    headers: {
      'x-skip-loader': true,
    },
    data: request,
  });
  return response.data;
};

const updateVehicleDepartments = async ({ request }) => {
  const response = await api({
    url: `VehicleDepartments/update`,
    method: 'POST',
    headers: {
      'x-skip-loader': true,
    },
    data: request,
  });
  return response.data;
};

const createUTTSVehicles = async ({ customerId, vehicleIds }) => {
  const response = await api({
    url: `Vehicles/CreateUTTSVehicles`,
    method: 'POST',
    headers: {
      'x-skip-loader': true,
    },
    data: {
      customerId,
      vehicleIds,
    },
  });
  return response.data;
};

const deleteVehicleDepartments = async ({ department }) => {
  const response = await api({
    url: `VehicleDepartments/delete`,
    method: 'POST',
    headers: {
      'x-skip-loader': true,
    },
    data: department,
  });
  return response.data;
};

const updateActivationCodeForBP = async ({ request }) => {
  const response = await api({
    url: `Vehicles/UpdateActivationCodeForBP`,
    method: 'PUT',
    headers: {
      'x-skip-loader': true,
    },
    data: request,
  });
  return response.data;
};

const vehicleManagementServices = {
  getVehicleList,
  getUpdateVehicleLimitsList,
  getUpdateVehiclesUsableDays,
  removeLimitRestriction,
  getUpdateVehicleDisable,
  deletePlateAllDevices,
  getDownloadVehicleFile,
  getVehicleSummaryPdfReport,
  createVehicleDepartments,
  updateVehicleDepartments,
  deleteVehicleDepartments,
  updateActivationCodeForBP,

downloadActivationCodeForBP,
  createUTTSVehicles,

};

export default vehicleManagementServices;
